import React from 'react';
import { Col, Row } from 'react-bootstrap';

const NewsLetter = () => {
    const handleSubmit = async (e) => {
        e.preventDefault();
    }

    return (
        <Col lg={12}>
            <div className='newsletter-bx'>
                <Row>
                    <Col xl={5} lg={6} md={4}>
                        <h3>Subscribe to our Newsletter</h3>
                    </Col>
                    <Col xl={7} lg={6} md={8}>
                        <form onSubmit={handleSubmit}>
                            <div className="new-email-bx">
                                <input type="email" placeholder='Enter Your Email Address' />
                                <button type="submit">Submit</button>
                            </div>
                        </form>
                    </Col>
                </Row>
            </div>
        </Col>
    )
}

export default NewsLetter;